import React from "react";
import { Form, Formik, FormikProps } from "formik";
import { Button, Box, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import InvoiceFilterModel from "../../core/api/invoice/InvoiceFilterModel";
import { DatePicker } from "../common/DatePicker";
import ManagersSelectInput from "../classifier/ManagersSelectInput";
import { translations } from "../../translations/common";

const RootForm = styled(Form)({
  width: '100%',
});

const MarginContainer = styled(Grid)(({ theme }) => ({
  margin: theme.spacing(1),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
  width: '100%',
}));

const DatePickerContainer = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1),
  width: '100%',
}));

const StyledManagersSelect = styled(ManagersSelectInput)(({ theme }) => ({
  margin: theme.spacing(1),
  width: '100%',
}));

const InputsContainer = styled(Box)({
  width: '100%',
  '& .MuiInputBase-root': { width: '100%' },
  '& .MuiOutlinedInput-root': { width: '100%' },
  '& .MuiFormControl-root': { width: '100%' }
});

interface Props {
  filter: InvoiceFilterModel;
  onFilterChange: (filter: InvoiceFilterModel) => void;
}

const InvoiceFilterForm: React.FC<Props> = (props) => {
  const onClear = () => {
    props.onFilterChange({
      dateFrom: "",
      dateTo: "",
      author: "",
    });
  };

  return (
    <Formik
      initialValues={props.filter}
      enableReinitialize
      onSubmit={(values, actions) => {
        props.onFilterChange(values);
        actions.setSubmitting(false);
      }}
    >
      {(props: FormikProps<InvoiceFilterModel>) => {
        const { values, handleChange, isSubmitting, errors } = props;
        return (
          <RootForm>
            <InputsContainer>
              <MarginContainer
                container
                direction="column"
                justifyContent="center"
                alignItems="stretch"
                spacing={1}
              >
                <Grid size={12}>
                  <DatePickerContainer>
                    <DatePicker
                      id="dateFrom"
                      name="dateFrom"
                      label={translations.invoice.filter.dateFrom}
                      value={values.dateFrom}
                      onChange={handleChange}
                      error={!!errors.dateFrom}
                      helperText={errors.dateFrom}
                      fullWidth
                    />
                  </DatePickerContainer>
                </Grid>
                <Grid size={12}>
                  <DatePickerContainer>
                    <DatePicker
                      id="dateTo"
                      name="dateTo"
                      label={translations.invoice.filter.dateTo}
                      value={values.dateTo}
                      onChange={handleChange}
                      error={!!errors.dateTo}
                      helperText={errors.dateTo}
                      fullWidth
                    />
                  </DatePickerContainer>
                </Grid>
                <Grid size={12}>
                  <StyledManagersSelect
                    name="author"
                    labelId="user-responsible-label"
                    id="author"
                    value={values.author}
                    label={translations.invoice.filter.author}
                    fullWidth
                    onChange={handleChange}
                  />
                </Grid>
                <Grid size={12}>
                  <StyledButton
                    type="submit"
                    disabled={isSubmitting}
                    variant="contained"
                    color="primary"
                    fullWidth
                  >
                    {translations.invoice.filter.buttons.filter}
                  </StyledButton>
                  <StyledButton
                    type="button"
                    variant="contained"
                    color="secondary"
                    onClick={onClear}
                    fullWidth
                  >
                    {translations.invoice.filter.buttons.clear}
                  </StyledButton>
                </Grid>
              </MarginContainer>
            </InputsContainer>
          </RootForm>
        );
      }}
    </Formik>
  );
};

export default InvoiceFilterForm;
